export const countriesData = [
  {
    id: 1,
    countryCode: "AS",
    countryId: "684",
    countryImage: "assets/img/flags/as.png",
    countryName: "American Samoa (+684)",
    key: "1"
  },
  {
    id: 2,
    countryCode: "AD",
    countryId: "376",
    countryImage: "assets/img/flags/ad.png",
    countryName: "Andorra (+376)",
    key: "2"
  },
  {
    id: 3,
    countryCode: "AO",
    countryId: "244",
    countryImage: "assets/img/flags/ao.png",
    countryName: "Angalo (+244)",
    key: "3"
  },
  {
    id: 4,
    countryCode: "AI",
    countryId: "1264",
    countryImage: "assets/img/flags/ai.png",
    countryName: "Anguilla (+1264)",
    key: "4"
  },
  {
    id: 5,
    countryCode: "AQ",
    countryId: "672",
    countryImage: "assets/img/flags/qa.png",
    countryName: "Antarctica (+672)",
    key: "5"
  },
  {
    id: 6,
    countryCode: "AG",
    countryId: "1268",
    countryImage: "assets/img/flags/ag.png",
    countryName: "Antigua & Barbuda (+1268)",
    key: "6"
  },
  {
    id: 7,
    countryCode: "AR",
    countryId: "54",
    countryImage: "assets/img/flags/ar.png",
    countryName: "Argentina (+54)",
    key: "7"
  },
  {
    id: 8,
    countryCode: "AU",
    countryId: "61",
    countryImage: "assets/img/flags/au.png",
    countryName: "Australia (+61)",
    key: "8"
  },
  {
    id: 9,
    countryCode: "AT",
    countryId: "43",
    countryImage: "assets/img/flags/at.png",
    countryName: "Austria (+43)",
    key: "9"
  },
  {
    id: 10,
    countryCode: "AZ",
    countryId: "994",
    countryImage: "assets/img/flags/az.png",
    countryName: "Azerbaijan (+994)",
    key: "10"
  },
];
